export default {
    person: {
        wzTZ: 'キングオナーバックステージ管理システム通知発表',
        wzKF: '開発者の連絡先情報',
        QQ1: 'QQ番号1',
        QQ2: 'QQ番号2',
        mailbox: 'メールボックス',
        browser: 'ブラウザー',
        RecommendedUse: '推奨される使用方法',
        mattersNeedingAttention: '筆記',
        mattersNeedingAttention1: 'オリジナルを変更して商業目的で使用することは禁じられています',
        mattersNeedingAttention2: 'このページは、開発者がコミュニケーションを取り、学ぶことのみを目的としています',
        version: 'バージョン番号',
    },
    home:{
        wzry:"ログイン",
        game:'ログイン',
        account:'口座番号を入力してください',
        password:'パスワードを入力してください',
        remember:'パスワードを記憶する'
    },
    Login:{
        name:"ようこそ",
        register:"入る",
        logon:"ログイン",
        ZY:"紅葉はやや涼しくて濃い",
        ReSelect:"し 直す"
    }
};